import { render, staticRenderFns } from "./PermissionTree.vue?vue&type=template&id=7f56cf23&scoped=true&"
import script from "./PermissionTree.vue?vue&type=script&lang=js&"
export * from "./PermissionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56cf23",
  null
  
)

export default component.exports